import gql from 'graphql-tag'

export default gql`
query listLoyaltyCards($params: ListQueryArgs $filter: LoyaltyCardFilterArgs) {
	cashAssist {
		listLoyaltyCards(params: $params filter: $filter) {
			total
			items {
        id
        name
      }
		}
	}
}`
